module.exports = __webpack_public_path__ + "static/media/churrasqueira2.47ccd5c8.jpg";